<template>
  <div class="app-layout">
    <el-drawer
      class="tw-mb-0 tw-w-280px sm:tw-w-380px"
      size="100%"
      title=""
      :visible.sync="sidebarVisible"
      direction="ltr"
    >
      <side-bar
        v-on:displayRolesModal="value => (displayUserRoles = value)"
        v-on:change-route="sidebarVisible = false"
      />
    </el-drawer>
    <el-container>
      <el-col :span="24" v-loading="appLoading">
        <nav-bar v-on:displaySidebar="value => (sidebarVisible = value)" />
        <div class="tw-mt-4 content">
          <slot />
        </div>
      </el-col>
      <el-dialog
        width="100vw"
        height="100vh"
        top="0"
        title="Switch Role"
        class="role-switch-dialog"
        :visible.sync="displayUserRoles"
      >
        <h3 slot="title">Switch Role</h3>
        <role-switcher @closeModal="displayUserRoles = false" />
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import SideBar from "@/components/SideBar.vue";
import RoleSwitcher from "@/components/RoleSwitcher.vue";

export default {
  components: {
    NavBar,
    SideBar,
    RoleSwitcher
  },
  name: "AppLayout",
  props: {},
  computed: {
    appLoading() {
      return this.$store.getters["app/appLoading"];
    }
  },
  data() {
    return {
      sidebarVisible: false,
      displayUserRoles: false
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.app-layout {
  height: 100%;
  padding-bottom: 5rem !important;
  .el-container {
    height: 100%;
  }
  .content {
    padding: 16px;
    padding-bottom: 5rem;
    @media (max-width: $sm) {
      padding-bottom: 5rem !important;
    }
  }
}
::v-deep .el-loading-spinner {
  display: flex !important;
  justify-content: center !important;
  width: 100% !important;
}
</style>
